document.addEventListener('DOMContentLoaded', function () {

const {
  productData,
    bundle2Discount,
  bundle3Discount
} = window.bundleConfig;
    const hiddenQuantityInput = document.getElementById('hiddenQuantityInput');
    const variantIdInput = document.querySelector('.product-variant-id');
    const quantityOptions = document.querySelectorAll('.quantity-option');
    const variantSelects = document.querySelectorAll('.variant-select');

    localStorage.setItem(
  'velarisBundleDiscounts',
  JSON.stringify({
    bundle2: bundle2Discount,
    bundle3: bundle3Discount
  })
);

    // Function to update the hidden quantity input
    function updateQuantity(quantity) {
      hiddenQuantityInput.value = quantity;
    }

    // Function to update the variant ID input
function updateVariantId(variantId) {

  variantIdInput.value = variantId;

  const variant = productData.variants.find(v => v.id == variantId);

  if (!variant) return;

  refreshBundlePrices(variant);

}

function formatPrice(value) {
  return "$" + Number(value).toLocaleString("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}

function refreshBundlePrices(variant) {

  document.querySelectorAll(".quantity-option").forEach(option => {

  
    const qty = parseInt(option.dataset.quantity);

    const discounts = {
  2: bundle2Discount,
  3: bundle3Discount
};

const discount = discounts[qty] || 0;

    const originalUnitPrice = variant.price / 100;

const originalTotalPrice = originalUnitPrice * qty;

const totalPrice =
  originalTotalPrice - (originalTotalPrice * discount / 100);

const unitPrice = totalPrice / qty;

    const priceElement = option.querySelector(".bundle-price");
const unitElement = option.querySelector(".bundle-unit");
const compareElement = option.querySelector(".bundle-compare");
const saveElement = option.querySelector(".bundle-save");

priceElement.textContent = formatPrice(totalPrice);



unitElement.textContent = formatPrice(unitPrice) + (window.bundleConfig?.unitPriceSuffix || "/unidad");

if (compareElement) {
  compareElement.innerHTML =
    "<s>" +
    formatPrice(originalTotalPrice) +
    "</s>";
}

if (saveElement) {
  saveElement.textContent = "Save " + discount + "%";
}

  });

}

    // Event listener for quantity option selection
    quantityOptions.forEach((option) => {
      option.addEventListener('click', function () {
        // Remove active class from all options
        quantityOptions.forEach((opt) => opt.classList.remove('active'));
        // Add active class to clicked option
        this.classList.add('active');

        // Update quantity
        const quantity = this.dataset.quantity;
        updateQuantity(quantity);

        // Update variant ID (select the first option in the dropdown)
        const variantSelect = this.querySelector('.variant-select');
        if (variantSelect) {
          updateVariantId(variantSelect.value);
        }
      });
    });

    // Event listener for variant selection
    variantSelects.forEach((select) => {
      select.addEventListener('change', function () {
        updateVariantId(this.value);
      });
    });

    // Initialize with the first selected option
    const currentVariantId = variantIdInput.value;

if (currentVariantId) {
    updateVariantId(currentVariantId);
}

subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
  refreshBundlePrices(event.data.variant);
});

  });